import React, { useEffect, useState, useMemo } from "react";
import axios from "../../api/axiosAuth";
import "../../style/NotasPadre.css";

export default function PadreNotas() {
  const [hijos, setHijos] = useState([]);
  const [estudianteId, setEstudianteId] = useState("");
  const [notas, setNotas] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ================= HIJOS ================= */
  useEffect(() => {
    const load = async () => {
      const res = await axios.get("/padre/mis-hijos");
      setHijos(res.data || []);
    };
    load();
  }, []);

  /* ================= NOTAS ================= */
  const cargarNotas = async (id) => {
    try {
      setLoading(true);

      const res = await axios.get(`/padre/notas/${id}`);
      setNotas(res.data || []);
    } catch (err) {
      console.error(err);
      setNotas([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = (e) => {
    const id = e.target.value;
    setEstudianteId(id);

    if (id) cargarNotas(id);
    else setNotas([]);
  };

  /* ================= AGRUPAR ================= */
  const agrupado = useMemo(() => {
    return notas.reduce((acc, n) => {
      const key = `${n.materia_id}-${n.periodo_id}`;

      if (!acc[key]) {
        acc[key] = {
          materia: n.materia,
          periodo: n.periodo,
          items: [],
        };
      }

      acc[key].items.push(n);
      return acc;
    }, {});
  }, [notas]);

  /* ================= COLOR ================= */
  const color = (d) => {
    switch ((d || "").toLowerCase()) {
      case "superior": return "green";
      case "alto": return "#1976d2";
      case "basico": return "orange";
      case "bajo": return "red";
      default: return "#333";
    }
  };

  return (
    <div className="notas-container">
      <h2>📊 Calificaciones Detalladas</h2>

      {/* HIJOS */}
      <select value={estudianteId} onChange={handleSelect}>
        <option value="">Seleccione hijo</option>
        {hijos.map((h) => (
          <option key={h.estudiante_id} value={h.estudiante_id}>
            {h.nombres_estudiante} {h.apellidos_estudiante}
          </option>
        ))}
      </select>

      {loading && <p>⏳ Cargando...</p>}

      {!loading &&
        Object.values(agrupado).map((m, i) => (
          <div key={i} className="materia-card">

            <h3>📘 {m.materia}</h3>
            <small>📅 {m.periodo}</small>

            <div className="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Subitem</th>
                    <th>Nota</th>
                    <th>Desempeño</th>
                    <th>Descripción</th>
                  </tr>
                </thead>

                <tbody>
                  {m.items.map((n, idx) => (
                    <tr key={idx}>
                      <td>{n.nombre_item}</td>
                      <td>{n.subitem}</td>
                      <td><strong>{n.nota_final_item}</strong></td>
                      <td style={{ color: color(n.desempeño) }}>
                        {n.desempeño}
                      </td>
                      <td>{n.comentario || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

          </div>
        ))}
    </div>
  );
}
